export const infoAddToListing = (p) => `İlan <strong>${p}</strong> favori listenize eklendi.`;

export const infoRemoveToListing = (p) => `İlan <strong>${p}</strong> favori listenizden çıkarıldı.`;
